export const issuers = [
    {
        key: 'barclays',
        label: 'Barclays',
        regExp: /barclays/i
    },
    {
        key: 'lloyds',
        label: 'Lloyds',
        regExp: /lloyds/i
    },
    {
        key: 'rbs',
        label: 'RBS',
        regExp: /Royal Bank of Scotland/i
    },
    {
        key: 'coop',
        label: 'COOP',
        regExp: /Co-Operative/i
    }
];
